import { downloadOrderConfirmation } from '@app/services/documentsRepository';
import { useMutation } from '@tanstack/react-query';
import { saveAs } from 'file-saver';
interface Payload {
  orderId: string;
  orderNumber: string;
}

export const useDownloadOrderConfirmation = () => {
  const mutationFn = async ({ orderId, orderNumber }: Payload) => {
    const response = await downloadOrderConfirmation(orderId);
    saveAs(response, `Confirmation_${orderNumber}.pdf`);
  };

  return useMutation({
    mutationFn,
  });
};
